import React from "react";
import { ExclamationIcon } from "@heroicons/react/outline";

const RemoveFightConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  fightName,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 p-4">
      <div className="bg-white rounded-xl shadow-xl max-w-md w-full p-6">
        {/* Icon and Title */}
        <div className="flex items-center gap-3 mb-4">
          <div className="w-10 h-10 bg-red-100 rounded-full flex items-center justify-center flex-shrink-0">
            <ExclamationIcon
              className="w-6 h-6 text-red-600"
              aria-hidden="true"
            />
          </div>
          <div>
            <h3 className="text-lg font-bold text-dark-grey">Remove Fight</h3>
            <p className="text-sm text-medium-grey">
              This action cannot be undone
            </p>
          </div>
        </div>

        {/* Content */}
        <div className="mb-6">
          <p className="text-dark-grey">
            Are you sure you want to remove this fight from the event?
          </p>
          {fightName && (
            <p className="text-sm text-medium-grey mt-2 font-medium">
              {fightName}
            </p>
          )}
        </div>

        {/* Actions */}
        <div className="flex gap-3 justify-end">
          <button onClick={onClose} className="btn btn--secondary px-4 py-2">
            Cancel
          </button>
          <button onClick={onConfirm} className="btn btn--danger px-4 py-2">
            Remove Fight
          </button>
        </div>
      </div>
    </div>
  );
};

export default RemoveFightConfirmationModal;
